import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { HiX } from "react-icons/hi";
import PatientSearch from "@/components/patient/patient-search";
import { Button } from "@/components/ui";
import { useCommunication } from "@/contexts/chat-provider";
import { PatientSummary } from "@/types/patient";
import { GLOBAL_CHAT_CONSTANTS } from "./chat-constants";
const AddChatWindow: React.FC = () => {
  const $ = _c(16);
  const {
    openChat,
    isAddChatOpen,
    setIsAddChatOpen
  } = useCommunication();
  const [selectedPatient, setSelectedPatient] = useState();
  const searchPatientsWithPhoneNumber = _temp2;
  let t0;
  if ($[0] !== openChat || $[1] !== setIsAddChatOpen) {
    t0 = async patient_0 => {
      setSelectedPatient(patient_0);
      if (!patient_0) {
        return;
      }
      setIsAddChatOpen(false);
      await openChat(patient_0.id);
    };
    $[0] = openChat;
    $[1] = setIsAddChatOpen;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handlePatientSelect = t0;
  if (!isAddChatOpen) {
    return null;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: GLOBAL_CHAT_CONSTANTS.CHAT_WIDTH,
      height: GLOBAL_CHAT_CONSTANTS.CHAT_HEIGHT
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="ml-2 text-body-emphasis text-foreground-secondary">New Chat</span>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setIsAddChatOpen) {
    t3 = () => setIsAddChatOpen(false);
    $[5] = setIsAddChatOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HiX className="h-4 w-4" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <div className="flex h-14 items-center justify-between rounded-t-lg border bg-background-secondary p-2">{t2}<Button variant="ghost" className="p-1 text-foreground hover:text-foreground-secondary" onClick={t3}>{t4}</Button></div>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handlePatientSelect || $[11] !== selectedPatient) {
    t6 = <PatientSearch patient={selectedPatient} onPatientSelect={handlePatientSelect} placeholder="Search patient..." className="w-full p-2" autoFocus={true} showDateOfBirth={true} showPhoneNumber={true} searchFilter={searchPatientsWithPhoneNumber} />;
    $[10] = handlePatientSelect;
    $[11] = selectedPatient;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="relative z-10 flex flex-col rounded-t-lg bg-background/80 shadow-lg backdrop-blur-lg" style={t1}>{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default AddChatWindow;
function _temp(patient) {
  return patient.phoneNumber;
}
function _temp2(patients) {
  return patients.filter(_temp);
}